import React, { useState } from 'react';
import axios from 'axios';
import { auth } from '../firebase-config';
import { trainers } from '../constants';
import ModalComponent from './Modal';
import './EditClassModal.css';

const timeValue = value => {
  const match = String(value || '').trim().match(/^(\d{1,2}):(\d{2})\s*(am|pm)?$/i);
  if (!match) return '';
  let hours = Number(match[1]);
  if (match[3]) hours = hours % 12 + (match[3].toLowerCase() === 'pm' ? 12 : 0);
  return `${String(hours).padStart(2, '0')}:${match[2]}`;
};

export default function EditClassModal({ courseClass, onClose, onSaved }) {
  const [values, setValues] = useState({ trainerId: courseClass.trainerId || '',
    scheduledDateKey: courseClass.scheduledDateKey || '', startTime: timeValue(courseClass.startTime),
    endTime: timeValue(courseClass.endTime), status: courseClass.status || 'scheduled', reason: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const change = event => setValues(current => ({ ...current, [event.target.name]: event.target.value }));
  const save = async event => {
    event.preventDefault();
    if (saving) return;
    setSaving(true);
    setError('');
    try {
      if (!auth.currentUser) throw new Error('Please sign in again.');
      const token = await auth.currentUser.getIdToken();
      const { data } = await axios.post('https://australia-southeast1-upskillinstitute-au.cloudfunctions.net/editAdminClass', {
        classId: courseClass.id || courseClass.classId, expectedUpdatedAt: courseClass.updatedAt || '',
        original: { courseTypeKey: courseClass.courseTypeKey, trainerId: courseClass.trainerId,
          scheduledDateKey: courseClass.scheduledDateKey, delivery: courseClass.delivery || '' }, changes: values,
      }, { headers: { Authorization: `Bearer ${token}` } });
      onSaved(data);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Unable to save this class. Please try again.');
    } finally { setSaving(false); }
  };
  return <ModalComponent showModal setShowModal={() => { if (!saving) onClose(); }} contentStyle={{ maxHeight: '90vh', overflowY: 'auto' }}>
    <form className="editClassForm" onSubmit={save}>
      <h2>Edit Class</h2>
      <p>{courseClass.courseName || courseClass.courseLabel || courseClass.courseTypeKey}</p>
      <fieldset disabled={saving}>
        <label>Trainer<select name="trainerId" value={values.trainerId} onChange={change} required>
          <option value="">Select trainer</option>
          {trainers.map(trainer => <option key={trainer.trainerId} value={trainer.trainerId}>{trainer.name}</option>)}
        </select></label>
        <label>Class date<input type="date" name="scheduledDateKey" value={values.scheduledDateKey} onChange={change} required /></label>
        <div className="editClassTimes">
          <label>Start time<input type="time" name="startTime" value={values.startTime} onChange={change} /></label>
          <label>End time<input type="time" name="endTime" value={values.endTime} onChange={change} /></label>
        </div>
        <label>Status<select name="status" value={values.status} onChange={change}>
          <option value="scheduled">Scheduled</option><option value="cancelled">Cancelled</option>
        </select></label>
        <label>Reason for change<textarea name="reason" value={values.reason} onChange={change} required maxLength={1000} /></label>
      </fieldset>
      <p className="editClassNotice">Existing student sessions stay linked. Completed sign-offs and PDFs are retained as historical evidence. This updates this portal only, not the external RTO booking system.</p>
      {values.status === 'cancelled' && <p role="status">Cancellation pauses linked traffic assessments and prevents new submissions through matching class links. Students are not automatically notified.</p>}
      {error && <p role="alert">{error}</p>}
      <div className="editClassActions"><button type="button" disabled={saving} onClick={onClose}>Close</button><button type="submit" disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</button></div>
    </form>
  </ModalComponent>;
}
